export default __webpack_public_path__ + "static/media/raid--right.1d71ef69.png";